var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5.5H14.6666V3.66666C14.6666 2.64916 13.8508 1.83333 12.8333 1.83333H9.16659C8.14909 1.83333 7.33325 2.64916 7.33325 3.66666V5.5H3.66659C2.64909 5.5 1.84242 6.31583 1.84242 7.33333L1.83325 17.4167C1.83325 18.4342 2.64909 19.25 3.66659 19.25H18.3333C19.3508 19.25 20.1666 18.4342 20.1666 17.4167V7.33333C20.1666 6.31583 19.3508 5.5 18.3333 5.5ZM12.8333 5.5H9.16659V3.66666H12.8333V5.5Z",
    fill: "#005BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsSelectedIcon);
export default __webpack_public_path__ + "static/media/ProjectsSelectedIcon.1c7c313d404f6d6b909bcbb66a8ea83b.svg";
export { ForwardRef as ReactComponent };